<template>
  <div class="absolute right-2 top-2 z-50">
    <BaseDropdownOptions
      :options="parsedDropdownItems"
      @select="dispatchAction"
    >
      <template #trigger="{ isOpen }">
        <BaseButton
          :icon="['fas', 'ellipsis']"
          iconOnly
          :class="
            props.copilotFocused ? 'text-black' : '!text-primary-contrast'
          "
          size="sm"
          variant="tertiary"
          :pressed="isOpen"
        />
      </template>
    </BaseDropdownOptions>
  </div>
</template>

<script setup lang="ts">
import useApp from '../../composables/useApp';

const configStore = useConfigStore();
const router = useRouter();

const { refresh } = useApp();

const props = defineProps<{
  copilotFocused: boolean;
}>();

const emit = defineEmits<{
  (e: 'refresh'): void;
}>();

type HomeDropdownItem = {
  key: string;
  icon: string;
  label: string;
  action: () => void;
  divider?: boolean;
};

const triggerResizing = () => {
  configStore.setResizing(true);
};

const goToSettings = () => {
  router.push({ name: 'settings' });
};

const handleRefresh = () => {
  refresh();
  emit('refresh');
};

const dropdownItems: HomeDropdownItem[] = [
  {
    key: 'refresh',
    icon: 'rotate',
    label: 'home.dropdown.refresh',
    action: handleRefresh,
  },
  {
    key: 'resize',
    icon: 'arrows-left-right',
    label: 'home.dropdown.resize',
    action: triggerResizing,
  },
  {
    key: 'settings',
    icon: 'cog',
    label: 'home.dropdown.settings',
    action: goToSettings,
  },
  {
    key: 'logout',
    icon: 'power-off',
    label: 'home.dropdown.logout',
    divider: true,
    action: configStore.logout,
  },
];

const parsedDropdownItems = computed(() => {
  return dropdownItems.map(({ icon, label, key, divider }) => ({
    key,
    icon,
    label,
    divider,
  }));
});

const dispatchAction = (key: string) => {
  const item = dropdownItems.find((item) => item.key === key);
  if (item) {
    item.action();
  }
};
</script>
